<template>
  <form @submit.prevent>
    <div>
      <b-tabs v-if="showLibraryItems" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
        <b-tab :active="showLibraryItems">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>

          <!-- <div class="pl-5 pr-5">
            <recommendation-items
              v-if="selectedDepartment"
              rightPanelId="sidebar-process-recommendation"
              level="process"
              organizationScopedState="organizationDepartmentProcess"
              libraryScopedState="process"
              @interceptForSetParent="interceptForSetParent"
              :id="selectedDepartment._id"
            />
          </div> -->

          <LibraryItems
            rightPanelId="sidebar-new-process"
            organizationScopedState="organizationDepartmentProcess"
            libraryScopedState="process"
            :hideAdvancedFilter="true"
            @interceptForSetParent="interceptForSetParent"
          />
        </b-tab>

        <b-tab :active="isEditMode">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span v-if="isEditMode">{{ $t("common.update") }}</span>
              <span v-else>{{ $t("process.new") }}</span>
            </span>
          </template>

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            :placeholder="$t('process.name')"
            :label="$t('process.name')"
          />


          <!-- TKP-80 / tasarım s.11: birden çok yetkili; ekleme ekranında ekleyen kullanıcı ön dolu gelir.
               TKP-185 md.70b: yetkili alanı yalnız yeteneği olana; süreç/birim yöneticisi görmez, sunucu kendisini yazar -->
          <template v-if="canSetAdmins">
          <h6 class="mt-4">{{ $t("process.admins") }}</h6>

          <organization-member-select :multiple="true" :prefill-account-id="currentAccount && currentAccount._id" @onAclSelect="onProcessAdminSelect" />
          <small class="text-muted">{{ $t("process.admins-hint") }}</small>
          </template>
          <!-- :permissionFilter="['ORGANIZATION_ADMIN']" -->

          <h6 class="mt-4">{{ $t("department.text") }}</h6>
          <filter-select
            id="departmentFilter"
            ref="departmentFilter"
            :placeholder="$t('department.text')"
            :multiple="false"
            @filter="onSearch"
            :selected="form.department"
            @changed="onSelect"
          />

          <label class="mt-4">{{ $t("common.description") }}</label>
          <textarea v-model="form.description" class="form-control mb-4" :placeholder="$t('common.description')"></textarea>

          <sweet-button
            @click="save()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-tab>
      </b-tabs>

      <div v-else>
        <h2>
          <span v-if="!showLibraryItems && isEditMode">{{ entityName }} {{ $t("common.update") }}</span>
          <span v-else>{{ $t("process.new") }}</span>
        </h2>

        <sweet-input
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="text"
          layout="vertical"
          :placeholder="$t('process.name')"
          :label="$t('process.name')"
        />
        <template v-if="canSetAdmins">
        <h6 class="mt-4">{{ $t("process.admins") }}</h6>

        <organization-member-select :multiple="true" @onAclSelect="onProcessAdminSelect" :selected="selectedAdmins" />
        <small class="text-muted">{{ $t("process.admins-hint") }}</small>
        </template>
        <small v-else class="d-block text-muted mt-4" data-test="admins-readonly">{{ $t("process.admins-readonly") }}</small>
        <!-- :permissionFilter="['ORGANIZATION_ADMIN']"  -->


        <h6 class="mt-4">{{ $t("department.text") }}</h6>

        <filter-select
          id="departmentFilter1"
          ref="departmentFilter1"
          :placeholder="$t('department.text')"
          :multiple="false"
          @filter="onSearch"
          :selected="form.department"
          @changed="onSelect"
        />

        <label class="mt-4">{{ $t("common.description") }}</label>
        <textarea v-model="form.description" class="form-control mb-4" :placeholder="$t('common.description')"></textarea>

        <div v-if="form && form._id">
          <b-form-checkbox v-model="changeInAllHierarchy" name="check-button" switch class="switch d-inline"></b-form-checkbox>
          <label class="switch">{{ $t("common.change-in-all-hierarchy") }}</label>
        </div>
        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>

        <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
          {{ $t("common.cancel") }}
        </sweet-button>
      </div>
      <hr />
    </div>
  </form>
</template>

<script>
import LibraryItems from "@cc/library-items";
import OrganizationMemberSelect from "@cc/organization-member-select";
import RecommendationItems from "@cc/recommendation-items";

import SweetTextarea from "@c/form/sweet-textarea";
import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  props: ["hide-library", "reloadAfterSave"],
  components: {
    RecommendationItems,
    OrganizationMemberSelect,
    LibraryItems,
    SweetTextarea,
  },
  data() {
    return {
      form: { name: undefined, admins: undefined, department: undefined },
      changeInAllHierarchy: false,
      formError: undefined,
      entityName: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      department: {
        required,
      },
      admins: {
        // TKP-80: en az bir yetkili kalmak zorunda. TKP-185 md.70b: alanı göremeyen kullanıcıda kural uygulanmaz (sunucu korur / kendisini yazar)
        atLeastOne() {
          return !this.canSetAdmins || (!!this.form.admins && this.form.admins.length > 0);
        },
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...v, ...this.prepareFormForEdit(v), _id: v._id };
        this.entityName = this.form.name;
      },
    },
    copingEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...v, ...this.prepareFormForEdit(v), _id: v._id };
        this.entityName = this.form.name;
      },
    },
    selectedDepartment: {
      deep: true,
      immediate: true,
      handler(v) {
        this.onSelect(v);
      },
    },
  },
  computed: {
    /** TKP-185 md.70b */
    canSetAdmins() {
      return this.currentAccountCan("ENTITY_ADMINS__CAN_SET");
    },
    isUpdating() {
      return this.$store.getters["organizationDepartmentProcess/isUpdating"];
    },
    editedEntity() {
      return this.$store.getters["organizationDepartmentProcess/editedEntity"];
    },
    copingEntity() {
      return this.$store.getters["organizationDepartmentProcess/copingEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationDepartmentProcess/isEditMode"];
    },
    showLibraryItems() {
      return !this.hideLibrary && !this.isEditMode && !this.isCoping;
    },
    isCoping() {
      return this.$store.getters["organizationDepartmentProcess/isCoping"];
    },
    selectedDepartment() {
      return this.$store.getters["organizationDepartment/selectedEntity"];
    },
    /** TKP-80: seçim kutusu dizi taşıyor; tek yetkili de tek elemanlı dizi. */
    selectedAdmins() {
      return (this.form.admins ?? []).map((admin) =>
        admin.account
          ? { _id: admin._id ?? admin.account._id, accountId: admin.account._id, name: admin.account.name, email: admin.account.email, avatar: admin.account.avatar }
          : { _id: admin._id ?? admin.accountId, accountId: admin.accountId, name: admin.name, email: admin.email, avatar: admin.avatar }
      );
    },
  },
  mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        const { data } = await this.$store.dispatch("organizationDepartmentProcess/save", { payload: this.form, changeInAllHierarchy: this.changeInAllHierarchy });

        this.$store.commit("organizationDepartmentProcess/editedEntity", data);

        this.form = {};
        this.$toast.success(this.$t("common.success"));
        this.$root.$emit("bv::toggle::collapse", "sidebar-new-process");
        this.$emit("onSave", data);
        if (this.reloadAfterSave) {
          location.reload();
        }
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    cancel() {
      this.$store.commit("organizationDepartmentProcess/editedEntity");
      this.$store.commit("organizationDepartmentProcess/copingEntity");
      // this.$store.dispatch("organizationDepartmentProcess/resetForm");
    },
    async onSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDepartment/paginateForSearch`, {
        options: { limit: 20 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onSelect(item) {
      this.form = { ...this.form, department: item };
    },
    rightPanelClosed() {
    },
    interceptForSetParent(payload) {
      payload.department = this.selectedDepartment;
    },

    onProcessAdminSelect(items) {
      // TKP-80: çoklu seçimde dizi gelir; tek nesne gelirse diziye sarılır.
      const admins = Array.isArray(items) ? items : items ? [items] : [];
      this.form = { ...this.form, admins };
    },
  },
};
</script>
